// SPDX-License-Identifier: LicenseRef-Pachamama-Proprietary
// Copyright 2026 Pachamama Studios B.V. All rights reserved.

/**
 * The credit for the globe's own Earth, the NASA GIBS tiles (Blue Marble
 * by day, Black Marble by night). Both tile sources carry this one line,
 * so the Credits panel shows it once. The second sentence is the
 * acknowledgement GIBS asks for, word for word, so it is never translated
 * (rights audit, fix C37).
 */
export const GIBS_ATTRIBUTION =
  "NASA Blue Marble and Black Marble. We acknowledge the use of imagery provided by services from NASA's Global Imagery Browse Services (GIBS), part of NASA's Earth Science Data and Information System (ESDIS)."
